import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import "./TransactionTable.css";
import { Box, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
}));

export default function MiniStatementCard(props) {
  const classes = useStyles();

  // Getting Accounts Info
  let transactions;
  let availableBalance;
  let accountNo;
  // let miniStatementInfo = props.miniStatementData.map((item, i) => {
  //   console.log("item from Transaction Table: ", item);
  //   transactions = item.Body.Payload.Collection;
  //   availableBalance = item.Body.Payload.Available_Balance;
  //   accountNo = item.Body.Payload.Account_No;
  // });

  return (
    <div className="ms-wrapper ms-wrapper-bot ms-wrapper-border ms-width-70"
    style={{ border: "8px solid rgba(244, 176, 53, 0.8)" ,marginLeft:"10px"}}>
      <Box>
        <Typography align="center" variant="subtitle2" display="block" className="ministatement">
          Mini-Statement 
        </Typography>
      </Box>
      <div className={classes.root}>
        <div className={classes.section1}>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="subtitle2">
                Balance
              </Typography>
            </Grid>
            <Grid item>
              <Typography gutterBottom variant="subtitle1">
                {availableBalance}
              </Typography>
            </Grid>
            {/* <Grid item xs>
              <Typography gutterBottom variant="subtitle2">
                {accountNo}
              </Typography>
            </Grid> */}
            {/* <Grid item>
              <Typography gutterBottom variant="subtitle1">
                {availableBalance}
              </Typography>
            </Grid> */}
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="subtitle2">
                Account No
              </Typography>
            </Grid>
            <Grid item>
              <Typography gutterBottom variant="subtitle1">
                {accountNo}
              </Typography>
            </Grid>
          </Grid>
        </div>
        <Divider variant="middle" />
        {transactions.map((transactions, i) => (
          <div key={i} className={classes.section2}>
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography gutterBottom variant="subtitle2">
                  Value Date
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Value_Date}
                </Typography>
              </Grid>
            </Grid>
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography gutterBottom variant="subtitle2">
                  Amount
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {parseFloat(transactions.Amount).toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography gutterBottom variant="subtitle2">
                  Transaction
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Type_Of_Txn}
                </Typography>
              </Grid>
            </Grid>
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography gutterBottom variant="subtitle2">
                  Current Balance
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {parseFloat(transactions.Curr_Balance).toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
            <Grid container alignItems="center">
              <Box>
                <Typography align="center" display="block" variant="body1">
                  {transactions.Narration}
                </Typography>
              </Box>
            </Grid>

            {/* <Grid container alignItems="center">
              <Grid item xs>
                <Typography gutterBottom variant="body1">
                    Value Date
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Value_Date}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom variant="body1">
                    Post Date
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Post_Date}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom variant="body1">
                    Transaction Type
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Type_Of_Txn}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom variant="body1">
                    Amount
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Amount}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom variant="body1">
                    Current Balance
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body1">
                  {transactions.Curr_Balance}
                </Typography>
              </Grid>
            </Grid> */}
            {/* <Paper>
              <Typography gutterBottom variant="body1">
                {transactions.Value_Date}
              </Typography>
            </Paper> */}
            {/* <div>
              <Chip className={classes.chip} label="Extra Soft" />
              <Chip className={classes.chip} color="primary" label="Soft" />
              <Chip className={classes.chip} label="Medium" />
              <Chip className={classes.chip} label="Hard" />
            </div> */}
          </div>
        ))}
        {/* <div className={classes.section2}>
          <Typography gutterBottom variant="body1">
            Select type
          </Typography>
          <div>
            <Chip className={classes.chip} label="Extra Soft" />
            <Chip className={classes.chip} color="primary" label="Soft" />
            <Chip className={classes.chip} label="Medium" />
            <Chip className={classes.chip} label="Hard" />
          </div>
        </div> */}
        {/* <div className={classes.section3}>
          <Button color="primary">Add to cart</Button>
        </div> */}
      </div>
    </div>
  );
}
